const validate = require('./validate');

const cliente = require('./cliente');
const meioMask = require('./meio-mask');





var theWindow = $(window).width();

$(document).ready(function() {

	if(theWindow < 1024) {
		// Menu celular
		$('.open-menu').on('click', function(){

			$('body').toggleClass('menu-aberto');
		});

		$('.open-sub').on('click', function(){

			if($(this).next('ul').is(':hidden')) {
				$(this).next('ul').css({
					'-webkit-transform' : 'translateX(0)',
					'-moz-transform' 	: 'translateX(0)',
					'-ms-transform' 	: 'translateX(0)',
					'transform' 		: 'translateX(0)',
					'display' 			: 'block'
				});
			} else {
				$(this).next('ul').css({
					'-webkit-transform' : 'translateX(-280px)',
					'-moz-transform' 	: 'translateX(-280px)',
					'-ms-transform' 	: 'translateX(-280px)',
					'transform' 		: 'translateX(-280px)',
					'display' 			: 'none'
				});
			}
		});

		$('.close-sub').on('click', function(){

			$('.dropdown').css({
				'-webkit-transform' : 'translateX(-280px)',
				'-moz-transform' 	: 'translateX(-280px)',
				'-ms-transform' 	: 'translateX(-280px)',
				'transform' 		: 'translateX(-280px)',
				'display' 			: 'none'
			});
		});
	}

	$('.fancy').fancybox({
		helpers : {
			title : {
				type : 'inside'
			},
			overlay : {
				locked : false
			}
		},
		afterShow: function() {
			$(':text').setMask();
		}
	});

	$(':text').setMask();
	
	$('[data-menu]').each(function(){
        var menu = $(this).data('menu');
        if ($('body').is('.'+menu)) {
            $(this).find('a:eq(0)').addClass('actv');
        }
    });

    $(window).on('scroll load', function() {
    	var scrollTop = axysY();
    	if(scrollTop > 0) {
    		$('.mobile-menu').addClass('menu-scroled');
    	} else {
    		$('.mobile-menu').removeClass('menu-scroled');
    	}
    });

	//Retorna top
	function axysY() {
		return $(window).scrollTop();
	}

	try {
		$('.carousel').each(function() {
			var $self = $(this);
			var autoplaySpeed = $self.data('autoplayspeed')|0		
			var $el = $(this);			
			
				$el.slick({
					autoplay: true,
					autoplaySpeed: autoplaySpeed||3000,
					responsive: [
						{
							breakpoint: 1024,
							settings: {
	
								arrows: false,
								dots: true
							}
						}
					]
				});

			
		});

	} catch (e) {
		console.error(e);		
	}


	$('.carousel-interna').slick({
		autoplay: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {

					arrows: false,
					dots: true
				}
			}
		] 
	});

	$('.carousel-depositions').slick({
		autoplay: true,
		autoplaySpeed: 6000,
		dots: true,
		arrows: false,
		useTransform: false,
		pauseOnHover: false
	});
	

	$('.carousel-products').slick({

		slidesToShow: 4,
		slidesToScroll: 4,
		arrows: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					dots: true
				}
			}
		]
	});	
	

	$('body').on('click','.component-qtd a',function() {
		var $self = $(this);
		var $box = $self.closest('.component-qtd');
		var $input = $box.find(':text');
		var action = $self.data('action');


		var max = $box.data('max')|0;
		var qtd = $input.val()|0;
		

		if ('add' == action) {
			qtd++;
		} else {
			qtd--;
		}
		if (qtd < 1) qtd = 1;
		if (qtd > max && max != 0) qtd = max;

		$input.val(qtd);		
		$input.trigger('change');
	});

	$('body').on('change','.component-qtd :text',function() {
		var $self = $(this);
		var $box = $self.closest('.component-qtd');
		var max = $box.data('max')|0;
		var qtd = $self.val()|0;

		if (qtd < 1) qtd = 1;
		if (qtd > max && max != 0) qtd = max;

		$self.val(qtd);
	});

	$('.acordeon > li > a').on('click', function() {

		if($(this).next('ul,div').is(':hidden')) {

			$('.target-acordeon').slideUp();
			$(this).next('ul,div').slideDown();
		} else {

			$('.target-acordeon').slideUp();
		}
	});

	$('.lazy').each(function(i) {

		setTimeout(function(){

			$('.lazy').eq(i).addClass('carregado')
		}, i * 200);
	});

	$('.carousel-product').slick({

		arrows: false,
		dots: true
	});

	$('.esqueci-a-senha').on('click', function() {

		$('.box-esqueci-a-senha').slideDown();
	});

	$('.close-senha').on('click', function() {

		$('.box-esqueci-a-senha').slideUp();
	});

	$('.padlock').on('click', function() {

		$(this).toggleClass('unlock');
		$(this).parent('.mapa').find('.lock').toggleClass('inactive');

		if($(this).hasClass('unlock')) {

			$(this).html('<i class="fa fa-unlock-alt" aria-hidden="true"></i>');
		} else {

			$(this).html('<i class="fa fa-lock" aria-hidden="true"></i>');
		}
	});

	$('.copy-address').on('click', function() {

		var html = $('.the-address').html();
		$('.address-target').append(`<hr /> ${html}`);
	});

	$('.btn-toggle-user-menu').on('click', function() {

		$('body').toggleClass('user-menu-open');
	});

	function createTable(row, column) {

		var table = '';
		if(column > 6) column = 6;

		for (var i = 1; i <= row; i++) {
			
			table += '<tr>';

				for(var j = 1; j <= column; j++) {
					
					if(j == 1) {
						table += '<td> Dia '+i+'</td>';
					}
					table += '<td class="">Insira seu prato aqui!</td>';
				}
			table += '</tr>'
		}

		$('.target-table').html(table);
	}

	$(function(){

		var dia = 1, semana = 1;

		$('.create-table .dias').on('change', function() {

			dia = $(this).find('option:selected').val();
		});

		$('.create-table .semana').on('change', function() {

			semana = $(this).find('option:selected').val();
			
			createTable(dia, 7);
			$('.padrao.padrao-bigger td:nth-child('+semana+'n+1), .padrao.padrao-bigger th:nth-child('+semana+'n+1)').remove();
		});

	});

	$('.tabs > li > a').on('click', function() {

		$('.tabs a').removeClass('actv');
		$(this).addClass('actv');

		var tab = $(this).data('tab');

		$('.tab-content').hide();
		$('.tab-content.tab-'+tab).fadeIn(100);
	});''

	$('.datepicker').each(function(){
		var $el = $(this);
		if ($el.attr('name') == 'data_nascimento') {
			$el.datepicker({
				maxDate: new Date(),
				changeMonth: true,
				changeYear: true
			});
		} else {
			$el.datepicker();
		}
	});

	$.datepicker.regional['pt-BR'] = {
        closeText: 'Fechar',
        prevText: '&#x3c;Anterior',
        nextText: 'Pr&oacute;ximo&#x3e;',
        currentText: 'Hoje',
        monthNames: ['Janeiro','Fevereiro','Mar&ccedil;o','Abril','Maio','Junho',
        'Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
        monthNamesShort: ['Jan','Fev','Mar','Abr','Mai','Jun',
        'Jul','Ago','Set','Out','Nov','Dez'],
        dayNames: ['Domingo','Segunda-feira','Ter&ccedil;a-feira','Quarta-feira','Quinta-feira','Sexta-feira','Sabado'],
        dayNamesShort: ['Dom','Seg','Ter','Qua','Qui','Sex','Sab'],
        dayNamesMin: ['Dom','Seg','Ter','Qua','Qui','Sex','Sab'],
        weekHeader: 'Sm',
        dateFormat: 'dd/mm/yy',
        firstDay: 0,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['pt-BR']);


	$('.another').on('change', function() {

		var value = $(this).find('option:selected').val();
		
		if(value === 'Outro') {
			
			$('.hidden-field').slideDown();
		} else {

			$('.hidden-field').slideUp();
		}
	});

	$('.acordeon input[type="radio"]').on('change', function() {

		if($(this).is(':checked')) {

			$('.acordeon-content').slideUp();
			$(this).parent('label').next('.acordeon-content').slideDown();
		}
	});

	$('.cupom-desconto').on('submit', function(e) {

		e.preventDefault();
		$('.cupom-content').slideDown();
	});

	$('.landing-close').on('click', function(){

		$(this).closest('.landing-page').slideUp();
	});

	$('.list-filter > li > a').on('click', function(e){

		e.preventDefault();
		$(this).addClass('filtered');
	});

	$('.carousel-marcas').slick({

		arrows: false,
		autoplay: true,
		autoplaySpeed: 5000,
		pauseOnHover: false
	});

	$('.carousel-recomendados').slick({

		slidesToShow: 6,
		slidesToScroll: 1
	});

	$('.ver-programa').on('click', function(){

		$('body, html').animate({scrollTop : $('#ver-programa').offset().top}, 1000);
	});

	$('body').on('click','[name=formFiltros] a', function() {
		var $self = $(this);
		var $form = $self.closest('form');

		var $input = $self.find(':checkbox');
		if ($input.is(':checked')) {
			$input.prop('checked',false);
		} else {
			$input.prop('checked','checked');
		}

		var timer = $form.data('timer');
		if (timer) {
			window.clearTimeout(timer);
		}
		timer = window.setTimeout(function(){
			$.fancybox.showLoading();
			$form.trigger('submit');
		},1500);
		$form.data('timer',timer);
	});

	$( "#dialog" ).dialog({
      	autoOpen: false,
      	modal: true,
      	width: 800,
      	maxWidth: 800,
      	show: {
        	effect: "fadeIn",
        	duration: 300
      	},
      		hide: {
        	effect: "fadeOut",
        	duration: 300
      	}
    });
 
    $( ".opener" ).on( "click", function() {
      	$( "#dialog" ).dialog( "open" );
    });

    $(window).on('load', function() {

    	$('.hidden-fancy').click();
    })
});

(function($, window, document){
	$(function() {

		require('./produto/index');
		require('./produto/interna');

		require('./cardapio-completo/index');

		require('./carrinho/finalizar');
		require('./carrinho/index');

		require('./contato/index');
		require('./contato/trabalhe-conosco');

		/*
		 * newsletter
		 */

		$('body').on('submit', '[name=formNewsletter]', function() {
			var $self = $(this);

			try	{

				if ($self.data('enviando')) return false;
				if (!$self.find('.required').validate()) return false;

				grecaptcha.ready(function () {
					grecaptcha.execute(window.recaptcha_site_key, { action: 'submit' }).then(function (token) {
						$self.find('[name=recaptcha_token]').remove();
						$self.append('<input type="hidden" name="recaptcha_token" value="' + token + '">');

				var callback = function(resp) {
					if (undefined != resp.redirect_url) {
						location.href = resp.redirect_url;
						return;
					}
					$self.data('enviando',false);
					if (undefined != resp.popup_url) {
						$.fancybox.open([{
							href: resp.popup_url,
							type: 'ajax'
						}]);						
						return;
					}

					$.fancybox.hideLoading();
					if (resp.success) {
						$self.find(':text').val('');
					}
					alert(resp.msg);
				};

				$self.data('enviando');
				$.fancybox.showLoading();

				$.ajax({
					url: $self.attr('action'),
					type: 'post',
					dataType: 'json',
					data: $self.serializeArray(),
					success: callback,
					error: function() {
						callback({
							success: false,
							msg: "Não foi possível enviar o formulário."
						});
					}
				});
			});
		}); 

			} catch (e) {
				console.log(e);
			}

			return false;
		});

		/*
		 * popup-home
		 */

		 window.setTimeout(function() {

			 var $popup = $('.popup-home');
			 if ($popup.length != 0) {
			 	var img = new Image();
			 	img.onload = function() {		 		
				 	$.fancybox.open([{
				 		href:'#flyer',
						autoResize : false,
						autoCenter : false,
						autoSize : true,
						showCloseButton: false,
						closeBtn    : false,
						closeClick  : false,
						helpers     : { 
							overlay : {closeClick: false} 
						},
						keys : {
							close  : null
						}
				 	}]);
			 	};
			 	img.src = $popup.find('img').attr('src');
			 }

		 });
		
		 /*
		  * mascara telefone
		  */

		$('body').on('keyup','[alt=phone]', function() {
			var $self = $(this);
			var phone = $self.val().replace(/\D/igm,'');

			if (11 == phone.length) {
				$self.setMask({mask:'(99) 99999-9999',autoTab:false});
			} else {
				$self.setMask({mask:'(99) 9999-99999',autoTab:true});
			}
		});
		$('[alt=phone]').trigger('keyup');

		//fim



	});
}(jQuery, window, document));


//////////////////
// WEBPACK FOOTER
// ../src/app.js
// module id = 57
// module chunks = 0